if (document.getElementById("loadMore")) {
  initLoadMoreButton();
}

function initLoadMoreButton() {
  var work = document.querySelector(".news-teaser");
  var items = Array.from(work.querySelectorAll(".news-teaser__item"));
  var loadMore = document.getElementById("loadMore");
  var maxItems = 3;
  var loadItems = 3;
  var hiddenClass = "hiddenStyle";
  var hiddenItems = Array.from(document.querySelectorAll(".hiddenStyle"));

  if (items.length <= 3) {
    loadMore.style.display = "none";
  }

  items.forEach(function (item, index) {
    // console.log(item.innerText, index);
    if (index > maxItems - 1) {
      item.classList.add(hiddenClass);
    }
  });

  loadMore.addEventListener("click", function () {
    [].forEach.call(
      document.querySelectorAll("." + hiddenClass),
      function (item, index) {
        if (index < loadItems) {
          item.classList.remove(hiddenClass);
        }

        if (document.querySelectorAll("." + hiddenClass).length === 0) {
          loadMore.style.display = "none";
        }
      }
    );
  });
}
